export const GET_CASE_SUMMARIES_REQUEST='caseSummariesReducer/GET_CASE_SUMMARIES_REQUEST'
export const GET_CASE_SUMMARIES_SUCCESS='caseSummariesReducer/GET_CASE_SUMMARIES_SUCCESS'
export const GET_CASE_SUMMARIES_FAILED='caseSummariesReducer/GET_CASE_SUMMARIES_FAILED'